export const tooltips: { [key: string]: string} = {
    applicantProgression: `If there has been any progression or change to any of
     the above in the last 5 years, you should select the most appropriate
     answer from this list.`,
};
